import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Form, Formik } from "formik";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import StepRoutes from "../../../Routes/steps_routes";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import LoadingPage from "../../../Components/layouts/loading";
import { CreateNewSI } from "../../../SchemaInfo/info";
import { createSISchema } from "../../../Schemas/Site Inspection/SI_create_schema";
import { useEffect } from "react";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";

import "react-datepicker/dist/react-datepicker.css";
import { FcKindle } from "react-icons/fc";

const CreateSiSchedules = () => {
  const [data, setData] = useState(CreateNewSI);
  const [availableSlotsForSelectedDates, setAvailableSlotsForSelectedDates] =
    useState([]);
  // const [selectData, setSelectDate] = useState([]);
  const [userSelectedSlots, setUserSelectedSlots] = useState([]);
  // const [client, setClient] = useState('')
  let { id } = useParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handelSubmit = () => {
    if (userSelectedSlots.length === 0) {
      return;
    }
    const isConfirmed = window.confirm(
      "All Remaining Slots are Made available to other Users"
    );
    if (!isConfirmed) return;
    setLoading(true);
    performRequest(
      "PATCH",
      `/bookSiteInspection/scheduleFinalDate/`,
      userSelectedSlots
    )
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "SI Created Successfully!");
          navigate(`/si-schedules`);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  const handleSlotSelect = (slot) => {
    setUserSelectedSlots([slot]);
  };


useEffect(()=>{
  if (id) {
    performRequest("GET", `/bookSiteInspection/getSlotsByOrderId/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setAvailableSlotsForSelectedDates(res.data);
        } else {
          Toast("error", "Error while getting Expense!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  } else {
    setAvailableSlotsForSelectedDates([]);
  }
},[])


  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/bookSiteInspection/getFinalDate`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting Expense!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcKindle></FcKindle>Create SI Schedules
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">Create SI Schedules</h2>
            </div>

            <Formik
              initialValues={data}
              validationSchema={createSISchema}
              onSubmit={handelSubmit}
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    <div className="card">
                      <div className="card-header">
                        <div className="col-4 form-label">
                          {" "}
                          Requested Time Slots{" "}
                        </div>{" "}
                      </div>
                      <div className="card-body">
                        <div className="row">
                          {availableSlotsForSelectedDates.length < 0 ? (
                            <p> Please Select Requested Schedule</p>
                          ) : availableSlotsForSelectedDates?.length > 0 ? (
                            availableSlotsForSelectedDates?.map(
                              (slot, index) => (
                                <div key={slot.id} className="col-md-3">
                                  <div
                                    className={`card my-1 ${
                                      userSelectedSlots.length > 0 &&
                                      userSelectedSlots[0]?.id === slot.id
                                        ? "bg-green text-white"
                                        : ""
                                    }`}
                                    onClick={() => handleSlotSelect(slot)}
                                    style={{
                                      cursor: "pointer",
                                      opacity:
                                        userSelectedSlots.length > 0 &&
                                        userSelectedSlots[0]?.id === slot.id
                                          ? 0.5
                                          : 1,
                                    }}
                                  >
                                    <div className="card-body">
                                      <p className="card-text">
                                        {`Date: ${slot?.prefferedDate}`}
                                        <br />
                                        {`Time: ${slot?.timeSlot}`}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              )
                            )
                          ) : (
                            <p>Please Select Requested Schedule</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <FormSubmitButton buttonText="Confirm Si Slot" />
                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default CreateSiSchedules;
